<header class="detail-view-header" [ngClass]="{ 'header-shadow': showHeaderShadow }">
  <kp-feedback-buttons
    class="hidden-print"
    *ngIf="card?.contentType !== cardContentType.domain"
    [card]="card"
    [preference]="card?.userState?.preference"
    [screen]="screen"
    [requestType]="requestType"
    [feedbackTitleInfo]="card?.title"
    [color]="(themeService.theme$ | async)?.primary"
    (feedbackClicked)="sendCardEvent($event)"></kp-feedback-buttons>
</header>

<div class="card-container" *ngIf="card; else loading" [ngClass]="{ 'is-safari': isSafari }">
  <section #imageContainer class="image-container hidden-print">
    <img
      class="big-image"
      *ngIf="card.cardImage?.url !== null && !card.primaryMedia?.isVideo"
      [src]="card.cardImage?.url + '?w=1218'"
      [alt]="card.cardImage?.description" />
  </section>
  <h3 class="card-topic" *ngIf="card.contentType === cardContentType.domain">{{ card.topic }}</h3>
  <section class="paragraph-container">
    <div class="card-body">
      <kp-audio-player
        class="hidden-print"
        [analyticsPageName]="analyticsPageName"
        [card]="card"
        [url]="card.primaryMedia.url"
        [title]="card.primaryMedia.title"
        *ngIf="card.primaryMedia?.isAudio"></kp-audio-player>
      <kp-video-player
        class="hidden-print"
        [altText]="card.cardImage?.description"
        [analyticsPageName]="analyticsPageName"
        [url]="card.primaryMedia.url"
        [title]="card.primaryMedia.title"
        [image]="card.cardImage?.url"
        *ngIf="card.primaryMedia?.isVideo"></kp-video-player>
      <kp-accordion-group
        class="hidden-print"
        [id]="card.id"
        *ngIf="card?.primaryMedia?.rawTranscript"
        [initialStateOpen]="false"
        (didChange)="transcriptAccordionChange($event)">
        <div acc-open class="audio-container">
          <span class="transcript-accordion-toggle" *ngIf="!transcriptAccordionOpen">Show Transcript</span>
          <span class="transcript-accordion-toggle" *ngIf="transcriptAccordionOpen">Hide Transcript</span>
        </div>
        <div acc-collapsible class="body-transcript">
          <kui-rich-text [richText]="card?.primaryMedia?.rawTranscript"></kui-rich-text>
        </div>
      </kp-accordion-group>
      <h3 class="card-topic" *ngIf="card.contentType === cardContentType.card">{{ card.topic }}</h3>
      <h3 class="card-title" [ngClass]="{ 'domain-title': card.contentType === cardContentType.domain }">
        {{ card.title }}
      </h3>
      <kui-rich-text [richText]="card.rawBody" [targetExternalLinks]="true"></kui-rich-text>
    </div>
    <ng-container *ngIf="card.userState?.isTracking && this.isPurposeful">
      <kp-action-reminder-detailed-view
        *ngIf="!card.userState?.isQuestComplete && !(card.userState.isCompleted && !card.isRepeatable)"
        class="reminders-container"
        [card]="card"></kp-action-reminder-detailed-view>
      <kp-habit-pairing
        *ngIf="!card?.isQuestCard && card?.isRepeatable"
        class="reminders-container"
        [card]="card"></kp-habit-pairing>
    </ng-container>
    <div class="breakout-container" *ngIf="card.why || card.how">
      <h2 *ngIf="card.why">Why It Matters</h2>
      <p *ngIf="card.why" class="breakout-paragraph">{{ card.why }}</p>
      <h2 *ngIf="card.how">Pro Tip</h2>
      <p *ngIf="card.how" class="breakout-paragraph">{{ card.how }}</p>
    </div>
  </section>

  <section class="link-container hidden-print" *ngIf="card.userState && card.contentType !== cardContentType.domain">
    <button
      (click)="addToOrRemoveFromActions($event, cardEventType.UNTRACK)"
      *ngIf="!card.userState?.isCompleted && isPurposeful && card?.isTrackingAndActionable"
      class="icon-action icon-btn remove">
      <svg-icon svgClass="link-svg" src="/assets/icons/minus-circle.svg"></svg-icon>
      <span class="link-text">Remove from Take Action</span>
    </button>
  </section>

  <section
    class="progress-bar-container"
    *ngIf="
      card.contentType !== cardContentType.domain &&
      card.userState?.availableItemCount &&
      card.userState?.completedItemCount > 0
    ">
    {{ card.userState.completedItemCount }} of {{ card.userState.availableItemCount }} Complete
    <kp-progress-bar
      class="progress-bar"
      [value]="card.userState.completedItemCount"
      [max]="card.userState.availableItemCount"
      [hasPrimaryColors]="true"></kp-progress-bar>
  </section>

  <section
    class="button-container hidden-print"
    *ngIf="
      card.contentType !== cardContentType.domain &&
      (card.cardLink.hasLink ||
        (card?.userState?.isCompleted && !card?.inQuest) ||
        card?.isActionable ||
        (card?.inQuest && !card?.userState?.isCompleted))
    ">
    <kp-call-to-action
      class="detail-button detail-button-reverse"
      *ngIf="card?.cardLink?.hasLink || ((card?.isQuestCard || card?.inQuest) && !card?.userState?.isCompleted)"
      (click)="linkClicked($event)"
      [link]="card && card.cardLink.hasLink ? card.cardLink : questActionType"
      [callToAction]="card.callToAction || (card?.inQuest && !card?.cardLink?.hasLink ? 'Mark Complete' : 'Reflect')"
      [card]="card"
      [isQuestCard]="card?.isQuestCard || card?.inQuest"
      [requestType]="requestType"
      [returnUrl]="returnUrl"
      (closeCard)="modalClose.emit(true)"
      data-e2e="call-to-action"></kp-call-to-action>
    <!--   Note: Quest screen check is needed here as there is nothing to signal that card is inside quest   -->
    <button
      class="button button-reverse button-pill uncomplete button-cta"
      (click)="markUncomplete($event)"
      *ngIf="!card?.inQuest && card?.userState?.isCompleted && isPurposeful && !card.isQuestCard">
      Mark Not Done
    </button>
    <button
      class="button button-reverse button-pill button-cta"
      *ngIf="!card?.userState?.isCompleted && isPurposeful && card?.isTrackingAndActionable && !card.isQuestCard"
      (click)="markComplete($event)">
      Did It!
    </button>
    <button
      class="button button-reverse button-pill button-cta"
      *ngIf="!card?.userState?.isCompleted && card?.isActionableAndNotTracking && isPurposeful"
      (click)="addToOrRemoveFromActions($event, cardEventType.TRACK)">
      Commit to Try It
    </button>
  </section>
  <kp-copyright class="hidden-screen" [product]="product"></kp-copyright>
</div>
<ng-template #loading>Loading...</ng-template>
